import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-modal-adicionais',
  templateUrl: './modal-adicionais.component.html',
  styleUrls: ['./modal-adicionais.component.css']
})
export class ModalAdicionaisComponent implements OnInit {

  adicionales = new FormControl('');

  @Input() public Adicionales;
  @Input() public ValorProducto;
  public AdicionalesSelected: Array<any> = [] ;
  total : number = 0;
  element: any;
  showModal : boolean;

  constructor(
    private routers:Router,
    private el: ElementRef,
    public activeModal: NgbActiveModal
    ) { 
      this.element = el.nativeElement;
    }



    ngOnInit() {
      console.log("Adicionales: ", this.Adicionales);
      console.log("cvalor producto: ", this.ValorProducto);
      console.log("total: ", this.total);

      this.total += Number(this.ValorProducto);

  }

  Testclick()
  {
    this.AdicionalesSelected = this.Adicionales.filter(val => {return val.selected === true});    

    localStorage.setItem("AdicionalesSelected",JSON.stringify(this.AdicionalesSelected));

    this.routers.navigate(['/Pagamento']);

    this.activeModal.close();



  }
  GoToPagamento(){

    this.activeModal.close();

    this.showModal = false;
    // this.element.style.display = 'none';

    localStorage.setItem("AdicionalesSelected",'[]');

    this.routers.navigate(['/Pagamento']);
  }

  AdicionalSelected(event){
     console.log("TEST TEST TEST", event.target.getAttribute('data-price'));

     if(event.target.checked)
     {
       this.total += Number(event.target.getAttribute('data-price'));
     }else
     {
      this.total -=  Number(event.target.getAttribute('data-price'));
     }    

  }
}
